import React from 'react';
import { Button, Icon, Modal, Header } from 'semantic-ui-react'

const EstaSeg7Btn = ({mensaje1, mensaje2, mensaje3, mensaje4, mensaje5, mensaje6, mensaje7,
                      imgIcon1, imgIcon2, imgIcon3, imgIcon4, imgIcon5, imgIcon6, imgIcon7,
                      open, styles, handleQuestionUpdDel}) => {
// console.log(mensaje1, mensaje2)

    return(
      <div>
        {(mensaje1||mensaje2||mensaje3||mensaje4||mensaje5||mensaje6||mensaje7) && 
          <Modal open={open} size="tiny" style={styles.modal} trigger={
            <Button style={styles.confirmar} name="btnUpdDel" id="btnUpdDel" className="ui right labeled icon" onClick={(ev)=>handleQuestionUpdDel(ev)} primary fluid>
              {(mensaje1) && <img src={imgIcon1} alt="Opción" align="right" height="16"/>}
              {(mensaje2) && <img src={imgIcon2} alt="Opción" align="right" height="16"/>}
              {(mensaje3) && <img src={imgIcon3} alt="Opción" align="right" height="16"/>}
              {(mensaje4) && <img src={imgIcon4} alt="Opción" align="right" height="16"/>}
              {(mensaje5) && <img src={imgIcon5} alt="Opción" align="right" height="16"/>}
              {(mensaje6) && <img src={imgIcon6} alt="Opción" align="right" height="16"/>}
              {(mensaje7) && <img src={imgIcon7} alt="Opción" align="right" height="16"/>}

              {(mensaje1) && mensaje1}
              {(mensaje2) && mensaje2}
              {(mensaje3) && mensaje3}
              {(mensaje4) && mensaje4}
              {(mensaje5) && mensaje5}
              {(mensaje6) && mensaje6}
              {(mensaje7) && mensaje7}
            </Button>
          }>
            {(mensaje1) && <Header icon='edit' color='red' content={mensaje1} />}
            {(mensaje2) && <Header icon='edit' color='red' content={mensaje2} />}
            {(mensaje3) && <Header icon='edit' color='red' content={mensaje3} />}
            {(mensaje4) && <Header icon='edit' color='red' content={mensaje4} />}
            {(mensaje5) && <Header icon='edit' color='red' content={mensaje5} />}
            {(mensaje6) && <Header icon='edit' color='red' content={mensaje6} />}
            {(mensaje7) && <Header icon='edit' color='red' content={mensaje7} />}

            <Modal.Content>
              <p>Esta usted seguro ?</p>
            </Modal.Content>
            <Modal.Actions>
                <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                    <Icon dato1="No" name='remove' /> No
                </Button>
                <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                    <Icon dato1="Si" name='checkmark' /> Si
                </Button>
            </Modal.Actions>
          </Modal>
        }
    </div> 
    )
  }

export default EstaSeg7Btn